import { render } from "./index.vue?vue&type=template&id=1ea1216e&scoped=true&ts=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=1ea1216e&lang=stylus&scoped=true"

import exportComponent from "/builds/CarrefourOneAPP/website/game/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ea1216e"]])

export default __exports__